import React from 'react'

export default function Field(props) {
	return (
		<div className={`field ${props.styleClass}`}>
		</div>
	)
}